export const ASSETS = {
  heroGold:
    "https://static.prod-images.emergentagent.com/jobs/ec6c83e7-0928-4b07-8243-239f410eea25/images/0ff6c43fcd5c026d555d5cba4f6562610dd2b81d54ffddce126fa912b797eac9.jpeg",
  maison:
    "https://static.prod-images.emergentagent.com/jobs/ec6c83e7-0928-4b07-8243-239f410eea25/images/90224fbc79e93757f5b9e952131720ee4785e623e60cd75d07f040a9f7180e09.jpeg",
  dominoLight:
    "https://static.prod-images.emergentagent.com/jobs/ec6c83e7-0928-4b07-8243-239f410eea25/images/7d29d27b8a808e0e62a3af2fe549fe43895036d7bd02731f979f7897d9ce410c.jpeg",
  maroquinerieHero:
    "https://static.prod-images.emergentagent.com/jobs/ec6c83e7-0928-4b07-8243-239f410eea25/images/d690c151e18681a190c09c25fa6d6a7046523086a63c38e1978339c8ce810094.jpeg",
};

export const VIDEO = {
  hero: "/videos/hero-maison.mp4",
  crisopea: "/videos/film-crisopea.mp4",
  domino: "/videos/film-domino.mp4",
};

export const POSTER = {
  hero: ASSETS.heroGold,
  crisopea: ASSETS.heroGold,
  domino: "/visuels/domino/domino-noire-i/domino-noire-i--plan-serre.webp",
};
